module.exports = __webpack_public_path__ + "static/media/group-26.61579ca7.svg";